module.exports = __webpack_public_path__ + "img/南京大公二手车交易中心有限公司.67b94d29.jpg";